import { initiateSession } from 'redux/modules/sessions/actions/initiate-session';
import resetSession from 'redux/modules/sessions/actions/reset-session';
import { setAccessToken } from 'redux/modules/sessions/actions/set-access-token';
import { redirectToLogin } from 'utils/login';

export const handle401 = ({ api, apiToCall, dispatch, getState, args }) => {
  if (api.service === 'token-client' && api.endpoint === 'token') {
    redirectToLogin();

    return;
  }

  dispatch(setAccessToken());

  // eslint-disable-next-line consistent-return
  return dispatch(initiateSession())
    .then(() => apiToCall(getState))
    .catch(error => {
      if (
        args?.iHandleStatusCodes &&
        error?.status &&
        args?.iHandleStatusCodes?.includes?.(error.status)
      ) {
        throw error;
      }

      dispatch(resetSession());
      redirectToLogin();

      if (args?.throwErrorOnUnauthorized) {
        throw error;
      }
    });
};
